import { callApi } from "@/api/api-core";

export const fetchInfo = function(ownerHandlesFailure) {
    return callApi(
        "POST",
        "v1/products/seatticket/info",
        undefined,
        ownerHandlesFailure
    );
};

export const calculatePrice = function(tripId, ownerHandlesFailure) {
    return callApi(
        "POST",
        "v3/products/seatticket/price/calculate",
        {
            tripId
        },
        ownerHandlesFailure
    );
};

export const createOrder = function(
    tripId,
    productId,
    seatTypeId,
    amountOfSeatsWanted,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v3/products/seatticket/order",
        {
            tripId,
            productId,
            seatTypeId,
            amountOfSeatsWanted,
            salesChannelIdentifier: "Webshop"
        },
        ownerHandlesFailure
    );
};
